import React, { useRef, useState } from "react";
import { appEnv } from "../../../../../appEnv";
import {
  notification,
  Spin,
  Card,
  Popconfirm,
  Icon,
  Tag,
  Empty,
  Tooltip,
  Button,
  Popover,
  Badge,
  Input,
  Modal,
  Select,
} from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import api from "../../../../../services/api";
import { openChargeReceipt } from "../../../../../utils/open-charge-receipt";
import { useFreire } from "../../../../../utils/freireContext";
import * as texts from "../../../../../pages/Users/locales";
import { formatters } from "../../../../../utils/formatters";
import { Show } from "../../../../../contexts/PermissionContext";
import InfoRow from "../../../../../components/InfoRow";
import { useOnMount } from "../../../../../hooks";
import { getBenefitDescription } from "../../../../Coupons/utils";
import { CSVLink } from "react-csv";
import {
  PowerPlugIcon,
  TicketIcon,
  // ZapIcon,
} from "../../../../../assets/icons";
import { BRANDS } from "./Details";
import {
  formatExcel,
  getHeaders,
} from "../../../../ChargesHistory/ListChargesHistory";
import { Copy } from "../../../../../components/Copy";
import { IdleStartRow } from "./components/IdleStartRow";
import { ChargeSessionStatusBadge } from "./components/ChargeSessionStatusBadge";
import { useWhitelabels } from "../../../../../components/WhitelabelThemesProvider";
import { ClockCircleOutlined } from "@ant-design/icons";
import { handleDownloadRefundReceipt } from "../../../../../utils/download-refund-voucher";
import { ChargePayer } from "../../../../../constants/charge-payer";

const SATISMETER_PROJECTS = {
  development: {
    projectId: "62f6418d9cc03568f60a3e0b",
    name: "[dev] App Tupi",
    surveys: {
      "first-charge": {
        surveyId: "62fbdd943523787e9b5cc8a0",
        name: "[dev] NPS 1ª Carga",
        metric: "nps",
      },
      "new-transactional": {
        surveyId: "6377dc4b764986ebee62c181",
        metric: "nps",
        name: "[dev] NPS Transacional",
      },
      transactional: {
        surveyId: "62fbde453523787e9b5cc8a1",
        metric: "csat",
        name: "[dev] [legado] CSAT Transacional",
      },
      recurrent: {
        surveyId: "62fbde533523787e9b5cc8a2",
        metric: "nps",
        name: "[dev] [legado] NPS Recorrente (90 dias)",
      },
    },
  },
  production: {
    projectId: "627089b68cfdd2cfbbd83e00",
    name: "App Tupi",
    surveys: {
      "first-charge": {
        surveyId: "627c8a989109c0186cf797a8",
        metric: "nps",
        name: "NPS 1ª Carga",
      },
      "new-transactional": {
        surveyId: "6377dc4a764986ebee62c180",
        metric: "nps",
        name: "NPS Transacional",
      },
      transactional: {
        surveyId: "62f640789cc03568f60a3e07",
        metric: "csat",
        name: "[legado] CSAT Transacional",
      },
      recurrent: {
        surveyId: "62f640a29cc03568f60a3e08",
        metric: "nps",
        name: "[legado] NPS Recorrente (90 dias)",
      },
    },
  },
};

const satismeterProject =
  SATISMETER_PROJECTS[
    appEnv.REACT_APP_ENV_NAME === "produção" ? "production" : "development"
  ];

// TODO: translate properly; multiple times in this file
// TODO: proper texts in locales file
const satismeterSurveyMetrics = {
  nps: {
    text: {
      pt: "NPS",
    },
    getResult: (rating) => {
      if (rating >= 9) {
        return "promoter";
      }
      if (rating >= 7) {
        return "neutral";
      }
      return "detractor";
    },
  },
  csat: {
    text: {
      pt: "CSAT",
    },
    getResult: (rating) => {
      if (rating >= 4) {
        return "satisfied";
      }
      if (rating >= 3) {
        return "neutral";
      }
      return "unsatisfied";
    },
  },
};

const satismeterResults = {
  promoter: {
    color: "#43c15f",
    text: { pt: "Promotor" },
  },
  passive: {
    color: "#fd9537",
    text: { pt: "Passivo" },
  },
  detractor: {
    color: "#e12d2d",
    text: { pt: "Detrator" },
  },
  satisfied: {
    color: "#43c15f",
    text: { pt: "Satisfeito" },
  },
  neutral: {
    color: "#fd9537",
    text: { pt: "Neutro" },
  },
  unsatisfied: {
    color: "#e12d2d",
    text: { pt: "Insatisfeito" },
  },
};

const BenefitDescription = ({ benefit, currency, freire }) => {
  const { text } = getBenefitDescription(benefit, currency, freire);

  return (
    <Tag color="purple" className="paymentStatusTag">
      <Icon
        component={() => <TicketIcon color="#722ed1" />}
        style={{
          marginRight: 3,
        }}
      />
      {text}
    </Tag>
  );
};


// TODO: finalizar carga

// TODO: total carregado em kWh
// TODO: país, moeda
// TODO: total gasto em estações tupinambá
// TODO: total economizado com cupons

// TODO: estação favorita
// TODO: tempo médio entre as cargas
// TODO: tempo desde a última carga
// TODO: tempo para a primeira carga

// TODO: ícone em cada campo da tabela
// TODO: exibir preço do kWh

// TODO: kWh carregado e árvores
// TODO: grupo de permissão

// TODO: estação ou empresa ou empresa mãe deletada

const hasBillingRegistry = (charge) =>
  charge?.billing_registry && Object.keys(charge.billing_registry).length > 0;

const getChargeDisplayAmounts = (charge) => {
  const billingRegistry = hasBillingRegistry(charge)
    ? charge.billing_registry
    : null;

  return {
    activationFeeValue:
      billingRegistry?.activationFeeValue ?? charge?.activationFeeValue,
    chargeFeesTotal:
      billingRegistry?.chargeFeesTotal ?? charge?.chargeFeesTotal,
    chargeValue: billingRegistry?.chargeValue ?? charge?.chargeValue ?? 0,
    discountValue: billingRegistry?.discountValue ?? charge?.discountValue ?? 0,
    energyValue: billingRegistry?.energyValue ?? charge?.energyValue ?? 0,
    idleValue: billingRegistry?.idleValue ?? charge?.idleValue ?? 0,
  };
};

const DiscountValue = ({ charge, freire }) => {
  const { chargeValue, discountValue } = getChargeDisplayAmounts(charge);

  const discountValueFormatted = (
    <span style={{ textDecoration: "line-through" }}>
      {formatters.currency(
        freire.userLanguage,
        charge.currency,
      )((chargeValue + discountValue) / 100)}
    </span>
  );

  return chargeValue > 0 ? (
    <Popover
      content={
        <div>
          <div>
            <div>
              <strong>{freire(texts.DISCOUNT)}:</strong>{" "}
              {formatters.currency(
                freire.userLanguage,
                charge.currency,
              )(discountValue / 100)}
            </div>
          </div>
        </div>
      }
    >
      {discountValueFormatted}
    </Popover>
  ) : (
    discountValueFormatted
  );
};

const PaymentStatus = ({ chargeValue, freire, paymentSuccess, posPayment }) => {
  if (!paymentSuccess) {
    return (
      <Tag color="red" className="paymentStatusTag" style={{ paddingLeft: 2 }}>
        <Icon type="close" style={{ color: "red", marginRight: 3 }} />
        {freire(texts.NOT_PAID)}
      </Tag>
    );
  }

  if (posPayment) {
    return (
      <Tag color="blue" className="paymentStatusTag" style={{ paddingLeft: 3 }}>
        <Icon
          type="info-circle"
          style={{ color: "#1890ff", marginLeft: 3, marginRight: 3 }}
        />
        {freire(texts.POS_PAYMENT)}
      </Tag>
    );
  }

  const paid = chargeValue >= 100;

  return (
    <Tag
      color="green"
      className="paymentStatusTag"
      {...(paid && { style: { paddingLeft: 5 } })}
    >
      <Icon
        type={paid ? "check" : "gift"}
        style={{ color: "#48ac16", marginRight: 3 }}
      />
      {freire(paid ? texts.PAID : texts.FREE)}
    </Tag>
  );
};

const PayChargeButton = ({ freire, onConfirm }) => {
  const [focused, setFocused] = useState(false);

  const toggleFocused = () => {
    setFocused((focused) => !focused);
  };

  const blur = () => {
    setFocused(false);
  };

  return (
    <Show when={"show-user-charges-reprocess"}>
      <Popconfirm
        placement="topRight"
        title={freire(texts.CONFIRM_PAY_CHARGE)}
        okType="danger"
        okText={freire(texts.YES)}
        cancelText={freire(texts.NO)}
        onConfirm={onConfirm}
        icon={<Icon type="question-circle-o" style={{ color: "red" }} />}
      >
        <Tooltip
          placement="topRight"
          title={freire(texts.PAY_CHARGE)}
          {...(focused && { visible: false })}
        >
          <Button
            shape="circle"
            size="small"
            ghost
            type="danger"
            onClick={toggleFocused}
            onMouseLeave={blur}
          >
            <Icon type="sync" />
          </Button>
        </Tooltip>
      </Popconfirm>
    </Show>
  );
};

const RefundConfirmContent = ({
  confirmText,
  reason,
  onReasonChange,
  placeholder,
}) => (
  <div style={{ width: 260 }}>
    <div style={{ marginBottom: 8 }}>{confirmText}</div>
    <Input
      value={reason}
      onChange={({ target: { value } }) => onReasonChange(value)}
      placeholder={placeholder}
    />
  </div>
);

const RefundActionButton = ({
  shouldRender,
  permission,
  tooltip,
  confirmText,
  charge,
  reasonState,
  setReasonState,
  onConfirm,
  iconType,
  buttonStyle,
  freire,
  loading,
}) => {
  if (!shouldRender) {
    return null;
  }

  const reasonValue = reasonState[charge._id] || "";
  const handleReasonChange = (value) => {
    setReasonState((prev) => ({
      ...prev,
      [charge._id]: value,
    }));
  };

  const handleConfirm = () => {
    if (!reasonValue || reasonValue.trim().length < 3) {
      notification.warning({
        message: freire(texts.ATTENTION),
        description: freire(texts.REFUND_REASON_REQUIRED),
      });
      return;
    }
    onConfirm(charge, reasonValue);
  };

  return (
    <Show when={permission}>
      <Tooltip placement="topRight" title={tooltip}>
        <Popconfirm
          placement="topRight"
          title={
            <RefundConfirmContent
              confirmText={confirmText}
              reason={reasonValue}
              placeholder={freire(texts.REFUND_REASON_PLACEHOLDER)}
              onReasonChange={handleReasonChange}
            />
          }
          okText={freire(texts.REFUND_CONFIRM_BTN)}
          cancelText={freire(texts.CANCEL)}
          icon={<Icon type="question-circle-o" />}
          onConfirm={handleConfirm}
          okButtonProps={{ disabled: loading }}
        >
          <Button
            shape="circle"
            size="small"
            ghost
            type="primary"
            style={buttonStyle}
            disabled={loading}
            loading={loading}
          >
            <Icon type={iconType} />
          </Button>
        </Popconfirm>
      </Tooltip>
    </Show>
  );
};

const RefundStatusTags = ({
  showWaiting,
  originalValue = 0,
  refundedValue = 0,
  currency,
  freire,
  charge,
  userID,
}) => {
  const hasOriginalValue =
    typeof originalValue === "number" && originalValue > 0;

  if (!showWaiting && !hasOriginalValue) {
    return null;
  }

  return (
    <>
      {showWaiting ? (
        <Tag color="gold" style={{ marginLeft: 8 }}>
          <ClockCircleOutlined />
          &nbsp;
          {freire(texts.WAITING_REFUND)}
        </Tag>
      ) : null}
      {hasOriginalValue ? (
        <Tag color="gold" style={{ marginLeft: 8 }}>
          <Icon type="undo" />
          &nbsp;
          {freire(texts.REFUNDED_VALUE)}:{" "}
          {formatters.currency(
            freire.userLanguage,
            currency,
          )(Math.max(0, refundedValue) / 100)}
        </Tag>
      ) : null}
      {hasOriginalValue && charge.payment?.id ? (
        <Tooltip placement="top" title={freire(texts.DOWNLOAD_REFUND_RECEIPT)}>
          <Button
            shape="circle"
            size="small"
            ghost
            type="primary"
            onClick={() =>
              handleDownloadRefundReceipt({
                record: charge,
                wallet_id: "any",
                user_id: userID,
                freire,
                transaction_id: charge.payment.id,
              })
            }
          >
            <Icon type="download" />
          </Button>
        </Tooltip>
      ) : null}
    </>
  );
};

const RefundDetails = ({
  showReason,
  reasonText,
  showAuthor,
  authorText,
  freire,
}) => {
  if (!showReason && !showAuthor) {
    return null;
  }

  return (
    <>
      {showReason && (
        <InfoRow
          labelSpan={7}
          valueSpan={17}
          label={`${freire(texts.REFUND_REASON)}:`}
          value={reasonText}
          bold={false}
        />
      )}
      {showAuthor && (
        <InfoRow
          labelSpan={7}
          valueSpan={17}
          label={`${freire(texts.REFUND_AUTHOR)}:`}
          value={authorText}
          bold={false}
        />
      )}
    </>
  );
};

const ApplyCouponButton = ({ charge, freire, onApplied }) => {
  const [visible, setVisible] = useState(false);
  const [loadingCoupons, setLoadingCoupons] = useState(false);
  const [applying, setApplying] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [selectedCouponId, setSelectedCouponId] = useState(undefined);

  const fetchAvailableCoupons = async () => {
    try {
      setLoadingCoupons(true);
      const { data } = await api.get(
        `/admin/charger-history/${charge._id}/available-coupons`,
      );
      setCoupons(data?.coupons ?? []);
    } catch (error) {
      notification.error({
        message: freire(texts.OOPS),
        description:
          error?.response?.data?.message || freire(texts.APPLY_COUPON_ERROR),
      });
    } finally {
      setLoadingCoupons(false);
    }
  };

  const openModal = () => {
    setSelectedCouponId(undefined);
    setCoupons([]);
    setVisible(true);
    fetchAvailableCoupons();
  };

  const closeModal = () => {
    if (applying) {
      return;
    }
    setVisible(false);
  };

  const applyCoupon = async () => {
    if (!selectedCouponId) {
      return;
    }
    try {
      setApplying(true);
      const { data } = await api.post(
        `/admin/charger-history/${charge._id}/apply-coupon`,
        { coupon_id: selectedCouponId },
      );

      const formatCurrency = formatters.currency(
        freire.userLanguage,
        charge.currency,
      );

      notification.success({
        message: freire(texts.ALL_RIGHT),
        description: data?.alreadyApplied
          ? freire(texts.APPLY_COUPON_ALREADY)
          : [
              freire(texts.APPLY_COUPON_SUCCESS),
              `${freire(texts.APPLY_COUPON_DISCOUNT)}: ${formatCurrency(
                (data?.discountValue ?? 0) / 100,
              )}`,
              `${freire(texts.APPLY_COUPON_NEW_VALUE)}: ${formatCurrency(
                (data?.newChargeValue ?? 0) / 100,
              )}`,
              `${freire(texts.APPLY_COUPON_WALLET_CREDIT)}: ${formatCurrency(
                (data?.walletCredit ?? 0) / 100,
              )}`,
            ].join(" · "),
      });

      setVisible(false);
      if (typeof onApplied === "function") {
        await onApplied();
      }
    } catch (error) {
      notification.error({
        message: freire(texts.OOPS),
        description:
          error?.response?.data?.message || freire(texts.APPLY_COUPON_ERROR),
      });
    } finally {
      setApplying(false);
    }
  };

  return (
    <Show when={"show-btn-apply-coupon"}>
      <Tooltip placement="topRight" title={freire(texts.APPLY_COUPON)}>
        <Button
          shape="circle"
          size="small"
          ghost
          type="primary"
          style={{ marginLeft: 8 }}
          onClick={openModal}
        >
          <Icon type="tag" />
        </Button>
      </Tooltip>
      <Modal
        title={freire(texts.APPLY_COUPON_TITLE)}
        visible={visible}
        onCancel={closeModal}
        okText={freire(texts.APPLY_COUPON_CONFIRM)}
        cancelText={freire(texts.CANCEL)}
        onOk={applyCoupon}
        confirmLoading={applying}
        okButtonProps={{ disabled: !selectedCouponId }}
      >
        <Spin spinning={loadingCoupons}>
          {!loadingCoupons && coupons.length === 0 ? (
            <Empty description={freire(texts.APPLY_COUPON_EMPTY)} />
          ) : (
            <>
              <Select
                showSearch
                style={{ width: "100%" }}
                placeholder={freire(texts.APPLY_COUPON_SELECT_PLACEHOLDER)}
                value={selectedCouponId}
                onChange={setSelectedCouponId}
                filterOption={(input, option) =>
                  String(option.props.children)
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {coupons.map((coupon) => {
                  const benefit = coupon.campaign?.benefit;
                  const benefitText = benefit
                    ? getBenefitDescription(
                        benefit,
                        charge.currency,
                        freire,
                      )?.text
                    : null;
                  return (
                    <Select.Option key={coupon._id} value={coupon._id}>
                      {coupon.cod}
                      {coupon.campaign?.name
                        ? ` — ${coupon.campaign.name}`
                        : ""}
                      {benefitText ? ` (${benefitText})` : ""}
                    </Select.Option>
                  );
                })}
              </Select>
              <div style={{ marginTop: 12, color: "#faad14" }}>
                <Icon type="info-circle" /> {freire(texts.APPLY_COUPON_INFO)}
              </div>
            </>
          )}
        </Spin>
      </Modal>
    </Show>
  );
};

ApplyCouponButton.propTypes = {
  charge: PropTypes.shape({
    _id: PropTypes.string,
    currency: PropTypes.string,
  }).isRequired,
  freire: PropTypes.func.isRequired,
  onApplied: PropTypes.func,
};

BenefitDescription.propTypes = {
  benefit: PropTypes.object,
  currency: PropTypes.string,
  freire: PropTypes.func,
};

DiscountValue.propTypes = {
  charge: PropTypes.object,
  freire: PropTypes.func,
};

PaymentStatus.propTypes = {
  chargeValue: PropTypes.number,
  freire: PropTypes.func,
  paymentSuccess: PropTypes.bool,
  posPayment: PropTypes.bool,
};

PayChargeButton.propTypes = {
  freire: PropTypes.func,
  onConfirm: PropTypes.func,
};

RefundConfirmContent.propTypes = {
  confirmText: PropTypes.node,
  reason: PropTypes.string,
  onReasonChange: PropTypes.func,
  placeholder: PropTypes.string,
};

RefundActionButton.propTypes = {
  shouldRender: PropTypes.bool,
  permission: PropTypes.string,
  tooltip: PropTypes.node,
  confirmText: PropTypes.node,
  charge: PropTypes.object,
  reasonState: PropTypes.object,
  setReasonState: PropTypes.func,
  onConfirm: PropTypes.func,
  iconType: PropTypes.string,
  buttonStyle: PropTypes.object,
  freire: PropTypes.func,
  loading: PropTypes.bool,
};

RefundStatusTags.propTypes = {
  showWaiting: PropTypes.bool,
  originalValue: PropTypes.number,
  refundedValue: PropTypes.number,
  currency: PropTypes.string,
  freire: PropTypes.func,
  charge: PropTypes.object,
  userID: PropTypes.string,
};

RefundDetails.propTypes = {
  showReason: PropTypes.bool,
  reasonText: PropTypes.node,
  showAuthor: PropTypes.bool,
  authorText: PropTypes.node,
  freire: PropTypes.func,
};

const Charges = ({ userID }) => {
  const { freire } = useFreire();
  const { getWhitelabelByAlias } = useWhitelabels();

  const [loading, setLoading] = useState(false);
  const [charges, setCharges] = useState([]);
  const [transactionIdFilter, setTransactionIdFilter] = useState("");
  const [idleRefundReason, setIdleRefundReason] = useState({});
  const [activationRefundReason, setActivationRefundReason] = useState({});

  const CSVLinkRef = useRef(null);
  const [chargesCsv, setChargesCsv] = useState([]);
  const [headersCsv, setHeadersCsv] = useState([]);

  const downloadExcel = async (chargesToExport) => {
    try {
      setChargesCsv(formatExcel({ docs: chargesToExport, freire }));
      setHeadersCsv(getHeaders({ freire }));
      setTimeout(() => {
        if (CSVLinkRef.current) {
          CSVLinkRef.current.link.click();
        } else {
          notification.error({
            message: "Ops...",
            description: freire(texts.ERROR_DOWNLOAD_FILE),
          });
        }
      }, 500);
    } catch (error) {
      notification.error({
        message: "Ops...",
        description: freire(texts.ERROR_CREATE_FILE),
      });
    }
  };

  const getUserCharges = async () => {
    try {
      setLoading(true);
      setCharges([]);

      const { data } = await api.get(`users_charged/${userID}`);

      setCharges(data);
    } catch (error) {
      notification.success({
        message: freire(texts.ALL_RIGHT),
        description: freire(texts.ERROR_GET_CHARGES_USERS),
      });
    } finally {
      setLoading(false);
    }
  };

  useOnMount(getUserCharges);

  const hasCouponApplied = (charge) =>
    charge.coupon2 instanceof Object &&
    Object.keys(charge.coupon2).length > 0;

  const couponAttributes = (charge) => {
    const attrs = {};

    if (hasCouponApplied(charge)) {
      attrs.value = (
        <span
          {...(charge.revertedCoupon && {
            style: { opacity: 0.75, textDecoration: "line-through" },
          })}
        >
          {charge.coupon2.cod}
        </span>
      );
      attrs.tooltip = (
        <div>
          <div>
            <div>
              <strong>{freire(texts.CAMPAIGN)}:</strong>{" "}
              <Copy>{charge.campaign?.name}</Copy>
            </div>
          </div>
          <Show when={"developer"}>
            <br />
            <div>
              <div>
                <strong>raw(coupon):</strong> <Copy>{charge.coupon2._id}</Copy>
              </div>
              <div>
                <strong>raw(campaign):</strong>{" "}
                <Copy>{charge.campaign?._id}</Copy>
              </div>
            </div>
          </Show>
          {charge.campaign instanceof Object && (
            <>
              <br />
              <div>
                {/* TODO: rever segunda div */}
                <div>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    // TODO: some querystring lib
                    href={`/dashboard/coupons/${charge.campaign._id}`}
                  >
                    {freire({ pt: "Ver cupons da campanha" })}
                  </a>
                </div>
              </div>
            </>
          )}
        </div>
      );
    }

    if (charge.campaign?.benefit instanceof Object) {
      if (!attrs.value) {
        attrs.value = (
          <span
            {...(charge.revertedCoupon && {
              style: { opacity: 0.75, textDecoration: "line-through" },
            })}
          >
            ✅
          </span>
        );
      }
      attrs.extraItems = (
        <BenefitDescription
          benefit={charge.campaign.benefit}
          currency={charge.currency}
          freire={freire}
        />
      );
    }

    return attrs;
  };

  const payUserCharge = async (chargeId) => {
    try {
      setLoading(true);

      await api.post(`/chargerHistory/${chargeId}/payment`);

      notification.success({
        message: freire(texts.ALL_RIGHT),
        description: freire(texts.PAY_CHARGE_SUCCESS),
      });

      await getUserCharges();
    } catch (error) {
      setLoading(false);

      const description =
        error?.response?.data?.message || error?.response?.data;

      notification.error({
        message: freire(texts.OOPS),
        description:
          description ?? error.message ?? freire(texts.PAY_CHARGE_ERROR),
      });
    }
  };

  const hasIdlePayment = (charge) => {
    return (
      charge.stationSnapshot?.idleFee?.enabled &&
      charge.meterValues?.lastTimestamp &&
      charge.startIdlePeriod
    );
  };

  const getActivationFeeValue = (charge) =>
    charge?.activationFeeValue ?? charge?.payment?.activationFeeValue ?? 0;

  const getOriginalActivationFeeValue = (charge) =>
    charge?.payment?.originalActivationFeeValue ?? 0;

  const getActivationFeeDisplayValue = (charge) => {
    return getActivationFeeValue(charge);
  };

  const hadActivationFeeRefund = (charge) =>
    getOriginalActivationFeeValue(charge) > 0 ||
    charge?.payment?.status === "waiting_activation_fee_refund";

  const getActivationFeeRefundedAmount = (charge) => {
    const originalValue = getOriginalActivationFeeValue(charge);
    if (originalValue <= 0) {
      return 0;
    }
    const currentValue = getActivationFeeValue(charge);
    return Math.max(0, originalValue - currentValue);
  };

  const getRefundAuthor = (charge, reason) => {
    return charge.payment?.refundAuthor?.find(
      (refund) => refund?.reason === reason,
    )?.email;
  };

  const submitRefundRequest = async ({
    charge,
    reasonText = "",
    endpoint,
    clearReason,
  }) => {
    try {
      setLoading(true);
      await api.post(endpoint, {
        reason: reasonText,
      });
      await api.post("/admin/tupi-finance/refund", {
        charger_history: charge._id,
      });

      notification.success({
        message: freire(texts.ALL_RIGHT),
        description: freire(texts.REFUND_DB_WEBHOOK_WARNING),
      });

      if (typeof clearReason === "function") {
        clearReason();
      }
      await getUserCharges();
    } catch (error) {
      setLoading(false);
      notification.error({
        message: freire(texts.OOPS),
        description: `${freire(texts.ERROR_REQUEST_REFUND)}: ${
          error?.response?.data?.message
        }`,
      });
    }
  };

  const requestRefundIdleFee = (charge, reasonText = "") =>
    submitRefundRequest({
      charge,
      reasonText,
      endpoint: `/charger_history/${charge._id}/refund_idle_fee`,
      clearReason: () =>
        setIdleRefundReason((prev) => ({ ...prev, [charge._id]: "" })),
    });

  const requestRefundActivationFee = (charge, reasonText = "") =>
    submitRefundRequest({
      charge,
      reasonText,
      endpoint: `/charger_history/${charge._id}/refund_activation_fee`,
      clearReason: () =>
        setActivationRefundReason((prev) => ({ ...prev, [charge._id]: "" })),
    });

  const getChargingModeInfo = (charge) => {
    if (
      !!charge.paymentMethodConfig &&
      !!charge.paymentMethodConfig.charge_value_limit &&
      charge.paymentMethodConfig.charge_value_limit > 0
    ) {
      return freire(
        texts.CHARGE_LIMITED_TO(
          formatters.currency(
            freire.userLanguage,
            charge.currency,
          )(charge.paymentMethodConfig.charge_value_limit / 100),
        ),
      );
    } else {
      return freire(texts.CHARGING_MODE_UNLIMITED);
    }
  };

  const hadIdlenessRefund = (charge) =>
    charge?.payment?.originalIdleValue > 0 ||
    charge?.payment?.status === "waiting_idleness_refund";

  const canShowRefundIdlenessBtn = (charge) => {
    const hasRefunded = charge?.payment?.originalIdleValue;
    const matchPaymentAndChargerHistory =
      charge?.payment?.idleValue === charge?.idleValue;
    return (
      !hasRefunded &&
      matchPaymentAndChargerHistory &&
      charge?.idleValue > 0 &&
      charge?.payment?.status !== "waiting_idleness_refund" &&
      charge?.payment?.status !== "refunded"
    );
  };

  const canShowRefundActivationFeeBtn = (charge) => {
    const activationFeeValue = charge?.activationFeeValue ?? 0;
    const paymentStatus = charge?.payment?.status;
    return (
      activationFeeValue > 0 &&
      !!charge?.payment?.id &&
      paymentStatus !== "waiting_activation_fee_refund" &&
      paymentStatus !== "refunded"
    );
  };

  const normalizedTransactionIdFilter = transactionIdFilter
    .trim()
    .toLowerCase();
  const filteredCharges = normalizedTransactionIdFilter
    ? charges.filter((charge) =>
        String(charge.transactionID ?? "")
          .toLowerCase()
          .includes(normalizedTransactionIdFilter),
      )
    : charges;
  const totalChargesValue = filteredCharges.reduce(
    (acc, charge) => acc + getChargeDisplayAmounts(charge).chargeValue / 100,
    0,
  );

  return (
    <div>
      {loading ? (
        <Spin
          style={{ display: "block", marginTop: 25 }}
          tip={freire(texts.LOADING_USER_CHARGES)}
        />
      ) : (
        <>
          <span className="drawerInfoTitle">
            {freire(texts.CHARGES_COUNT(filteredCharges.length))} -{" "}
            {formatters.currency(
              freire.userLanguage,
              filteredCharges[0]?.currency || charges[0]?.currency,
            )(totalChargesValue)}
          </span>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
              marginTop: 12,
              marginBottom: 12,
              flexWrap: "wrap",
            }}
          >
            <div style={{ minWidth: 260, flex: "1 1 320px" }}>
              <Input
                value={transactionIdFilter}
                onChange={({ target: { value } }) =>
                  setTransactionIdFilter(value)
                }
                placeholder={`${freire(texts.FILTER)} ${freire(
                  texts.CHARGE_ID,
                )} / transactionID`}
              />
            </div>
            <CSVLink
              ref={CSVLinkRef}
              data={chargesCsv}
              headers={headersCsv}
              filename={freire(
                texts.CSV_FILE_NAME_HISTORY(
                  moment().format(freire(texts.MONTH_TIME)),
                  userID,
                ),
              )}
            />
            <button
              style={{
                color: "#1890ff",
                cursor: "pointer",
                fontSize: 17,
                padding: "8px 16px",
                display: "inline-block",
                border: "none",
                background: "none",
              }}
              onClick={() => downloadExcel(filteredCharges)}
            >
              {freire(texts.DOWNLOAD_CHARGES_CSV)}
              &nbsp;&nbsp;
              <Icon type="download" />
            </button>
          </div>
          {filteredCharges.length > 0 ? (
            filteredCharges.map((charge, index) => (
              <Card
                key={charge._id}
                title={
                  <>
                    <Badge
                      count={filteredCharges.length - index}
                      overflowCount={Number.MAX_SAFE_INTEGER}
                      style={{
                        backgroundColor: "#fff",
                        color: "#999",
                        boxShadow: "0 0 0 1px #cececd inset",
                        width: 43,
                        marginRight: 24,
                      }}
                      title=" "
                    />
                    <Popover
                      content={
                        <div>
                          <div>
                            <div>
                              <strong>{freire(texts.CHARGE_ID)}:</strong>{" "}
                              <Copy>{charge.transactionID}</Copy>
                            </div>
                            <Show when={"developer"}>
                              <div>
                                <strong>ID:</strong> <Copy>{charge._id}</Copy>
                              </div>
                            </Show>
                            <div>
                              <strong>{freire(texts.STATION)}:</strong>{" "}
                              <Copy>{charge.station?.name}</Copy>
                            </div>
                            <div>
                              <strong>{freire(texts.STATION_ID)}:</strong>{" "}
                              <Copy>{charge.stationID}</Copy>
                            </div>
                            <div>
                              <strong>{freire(texts.CONNECTOR_ID)}:</strong>{" "}
                              <Copy>{charge.connectorID}</Copy>
                            </div>
                            <div>
                              <strong>{freire(texts.ADDRESS)}:</strong>{" "}
                              <Copy>
                                {charge.address ?? charge.station?.address}
                              </Copy>
                            </div>
                            <div>
                              <strong>{freire(texts.COMPANY)}:</strong>{" "}
                              <Copy>{charge.company?.name}</Copy>
                            </div>
                            <div>
                              <strong>{freire(texts.PARENT_COMPANY)}:</strong>{" "}
                              <Copy>{charge.parentCompany?.name}</Copy>
                            </div>
                          </div>
                          <br />
                          <div>
                            <div>
                              <strong>{freire(texts.APP)}:</strong>{" "}
                              <Copy>
                                {!charge.rfidTagCod &&
                                  getWhitelabelByAlias(charge.appName, true)
                                    ?.name}
                              </Copy>
                            </div>
                            <div>
                              <strong>{freire(texts.RFID_TAG)}:</strong>{" "}
                              <Copy>{charge.rfidTagCod}</Copy>
                            </div>
                          </div>
                          <Show when={"developer"}>
                            <br />
                            <div>
                              <div>
                                <strong>{freire(texts.COUNTRY_CODE)}:</strong>{" "}
                                <Copy>{charge.country}</Copy>
                              </div>
                              <div>
                                <strong>{freire(texts.CURRENCY_CODE)}:</strong>{" "}
                                <Copy>{charge.currency}</Copy>
                              </div>
                            </div>
                          </Show>
                          {typeof charge.station?.lat === "number" &&
                            typeof charge.station.lng === "number" && (
                              <>
                                <br />
                                <div>
                                  {/* TODO: rever segunda div */}
                                  <div>
                                    <a
                                      rel="noopener noreferrer"
                                      target="_blank"
                                      // TODO: some querystring lib
                                      href={`https://www.google.com/maps/search/?api=1&query=${charge.station.lat},${charge.station.lng}`}
                                    >
                                      {freire({ pt: "Ver no Google Maps" })}
                                    </a>
                                  </div>
                                </div>
                              </>
                            )}
                        </div>
                      }
                    >
                      {charge.rfidTagCod ? (
                        <Icon
                          type="tags"
                          style={{ marginRight: 8, color: "#a3a3a3" }}
                        />
                      ) : (
                        <img
                          src={
                            getWhitelabelByAlias(charge.appName, true)
                              ?.favicon
                          }
                          width={18}
                          style={{ marginRight: 8, marginBottom: 2 }}
                          alt={
                            getWhitelabelByAlias(charge.appName, true)?.name
                          }
                        />
                      )}
                      <span>
                        {charge.station?.name ?? "----"} (
                        {charge.company?.name ?? "----"})
                      </span>
                    </Popover>
                  </>
                }
                extra={
                  <>
                    {!charge.paymentSuccess && (
                      <PayChargeButton
                        freire={freire}
                        onConfirm={() => payUserCharge(charge._id)}
                      />
                    )}
                    <RefundActionButton
                      shouldRender={canShowRefundIdlenessBtn(charge)}
                      permission={"show-btn-refund-idleness"}
                      tooltip={freire(texts.REFUND_IDLE_FEE)}
                      confirmText={freire(texts.REFUND_IDLENESS_CONFIRM)}
                      charge={charge}
                      reasonState={idleRefundReason}
                      setReasonState={setIdleRefundReason}
                      onConfirm={requestRefundIdleFee}
                      iconType="dollar"
                      freire={freire}
                      loading={loading}
                    />
                    <RefundActionButton
                      shouldRender={canShowRefundActivationFeeBtn(charge)}
                      permission={"show-btn-refund-activationfee"}
                      tooltip={freire(texts.REFUND_ACTIVATION_FEE)}
                      confirmText={freire(texts.REFUND_ACTIVATION_CONFIRM)}
                      charge={charge}
                      reasonState={activationRefundReason}
                      setReasonState={setActivationRefundReason}
                      onConfirm={requestRefundActivationFee}
                      iconType="thunderbolt"
                      buttonStyle={{ marginLeft: 8 }}
                      freire={freire}
                      loading={loading}
                    />
                    {charge.paymentSuccess && !hasCouponApplied(charge) && (
                      <ApplyCouponButton
                        charge={charge}
                        freire={freire}
                        onApplied={getUserCharges}
                      />
                    )}
                    <Show when={"show-btn-ocpp"}>
                      <Tooltip
                        placement="topRight"
                        title={freire(texts.SEE_ON_OCPP(charge.transactionID))}
                      >
                        <Button
                          shape="circle"
                          size="small"
                          ghost
                          type="primary"
                          rel="noopener noreferrer"
                          target="_blank"
                          href={
                            charge.centralSystem
                              ? `/dashboard/ocpp/transactions/${charge.transactionID}`
                              : `https://ocpp.tupinambaenergia.com.br/steve/manager/transactions/details/${charge.transactionID}`
                          }
                        >
                          <Icon type="link" />
                        </Button>
                      </Tooltip>
                    </Show>
                    {charge.receiptFilePath && (
                      <Tooltip
                        placement="top"
                        title={freire(texts.SEE_RECEIPT)}
                      >
                        <Button
                          shape="circle"
                          size="small"
                          ghost
                          type="primary"
                          style={{ marginRight: 8 }}
                          onClick={() =>
                            openChargeReceipt(charge._id, freire, texts)
                          }
                        >
                          <Icon type="download" />
                        </Button>
                      </Tooltip>
                    )}
                  </>
                }
                className="chargeCard"
                headStyle={{ borderBottomColor: "#CECECD" }}
                bodyStyle={{ paddingTop: 8 }}
              >
                <InfoRow
                  labelSpan={7}
                  valueSpan={17}
                  label={`${freire(texts.CHARGE_SESSION_STATUS_LABEL)}:`}
                  value={
                    <ChargeSessionStatusBadge
                      status={charge.status}
                      freire={freire}
                    />
                  }
                  bold={false}
                />
                <InfoRow
                  labelSpan={7}
                  valueSpan={17}
                  label={`${freire(texts.ENERGY)}:`}
                  {...(charge.stopValue !== null && {
                    value: freire(
                      texts.KWH(
                        charge.stopValue.toLocaleString(freire.userLanguage, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }),
                      ),
                    ),
                  })}
                  bold={false}
                />
                <InfoRow
                  labelSpan={7}
                  valueSpan={17}
                  label={`${freire(texts.ENERGY_VALUE)}:`}
                  value={
                    <span>
                      {formatters.currency(
                        freire.userLanguage,
                        charge.currency,
                      )(
                        getChargeDisplayAmounts(charge).energyValue / 100,
                      )}
                    </span>
                  }
                  bold={false}
                />
                {(getActivationFeeDisplayValue(charge) > 0 ||
                  hadActivationFeeRefund(charge)) && (
                  <InfoRow
                    labelSpan={7}
                    valueSpan={17}
                    label={`${freire(texts.ACTIVATION_FEE_VALUE)}:`}
                    value={
                      <span>
                        {formatters.currency(
                          freire.userLanguage,
                          charge.currency,
                        )(getActivationFeeDisplayValue(charge) / 100)}
                      </span>
                    }
                    extraItems={
                      <RefundStatusTags
                        showWaiting={
                          charge?.payment?.status ===
                          "waiting_activation_fee_refund"
                        }
                        originalValue={getOriginalActivationFeeValue(charge)}
                        refundedValue={getActivationFeeRefundedAmount(charge)}
                        currency={charge.currency}
                        freire={freire}
                        charge={charge}
                        userID={userID}
                      />
                    }
                    bold={false}
                  />
                )}
                <RefundDetails
                  showReason={
                    hadActivationFeeRefund(charge) &&
                    Boolean(charge.payment?.activationFeeRefundReason)
                  }
                  reasonText={charge.payment?.activationFeeRefundReason}
                  showAuthor={
                    hadActivationFeeRefund(charge) &&
                    Boolean(getRefundAuthor(charge, "activation_fee"))
                  }
                  authorText={getRefundAuthor(charge, "activation_fee")}
                  freire={freire}
                />
                {hasIdlePayment(charge) && (
                  <InfoRow
                    labelSpan={7}
                    valueSpan={17}
                    label={`${freire(texts.IDLE_VALUE)}:`}
                    value={
                      typeof charge?.payment?.originalIdleValue === "number" ? (
                        <span
                          style={{
                            opacity: 0.75,
                            textDecoration: "line-through",
                          }}
                        >
                          {formatters.currency(
                            freire.userLanguage,
                            charge.currency,
                          )(charge.payment.originalIdleValue / 100)}
                        </span>
                      ) : charge.idleFeeForgivenValue > 0 ? (
                        <span
                          style={{
                            opacity: 0.75,
                            textDecoration: "line-through",
                          }}
                        >
                          {formatters.currency(
                            freire.userLanguage,
                            charge.currency,
                          )(charge.idleFeeForgivenValue / 100)}
                        </span>
                      ) : (
                        <span>
                          {formatters.currency(
                            freire.userLanguage,
                            charge.currency,
                          )(getChargeDisplayAmounts(charge).idleValue / 100)}
                        </span>
                      )
                    }
                    extraItems={
                      <>
                        {charge?.payment?.status ===
                        "waiting_idleness_refund" ? (
                          <Tag color="gold" style={{ marginLeft: 8 }}>
                            <ClockCircleOutlined />
                            &nbsp;
                            {freire(texts.WAITING_REFUND)}
                          </Tag>
                        ) : null}
                        {charge?.payment?.originalIdleValue > 0 ? (
                          <Tag color="gold" style={{ marginLeft: 8 }}>
                            <Icon type="undo" />
                            &nbsp;
                            {freire(texts.REFUNDED_VALUE)}:{" "}
                            {formatters.currency(
                              freire.userLanguage,
                              charge.currency,
                            )(
                              Math.max(
                                0,
                                (charge.payment.originalIdleValue -
                                  getChargeDisplayAmounts(charge).idleValue ||
                                  0) / 100,
                              ),
                            )}
                          </Tag>
                        ) : null}
                        {charge?.payment?.originalIdleValue > 0 &&
                          charge.payment?.id && (
                            <Tooltip
                              placement="top"
                              title={freire(texts.DOWNLOAD_REFUND_RECEIPT)}
                            >
                              <Button
                                shape="circle"
                                size="small"
                                ghost
                                type="primary"
                                onClick={() =>
                                  handleDownloadRefundReceipt({
                                    record: charge,
                                    wallet_id: "any",
                                    user_id: userID,
                                    freire,
                                    transaction_id: charge.payment.id,
                                  })
                                }
                              >
                                <Icon type="download" />
                              </Button>
                            </Tooltip>
                          )}
                        {charge.idleFeeForgivenValue > 0 ? (
                          <Tag color="cyan" style={{ marginLeft: 8 }}>
                            <Icon type="gift" />
                            &nbsp;
                            {freire(texts.IDLE_FEE_FORGIVEN_VALUE)}
                          </Tag>
                        ) : null}
                      </>
                    }
                    bold={false}
                  />
                )}
                <RefundDetails
                  showReason={
                    hadIdlenessRefund(charge) &&
                    Boolean(charge.payment?.idleRefundReason)
                  }
                  reasonText={charge.payment?.idleRefundReason}
                  showAuthor={
                    hadIdlenessRefund(charge) &&
                    Boolean(getRefundAuthor(charge, "idleness"))
                  }
                  authorText={getRefundAuthor(charge, "idleness")}
                  freire={freire}
                />
                <InfoRow
                  labelSpan={7}
                  valueSpan={17}
                  label={`${freire(texts.COUPON)}:`}
                  bold={false}
                  {...couponAttributes(charge)}
                />
                <InfoRow
                  labelSpan={7}
                  valueSpan={17}
                  label={`${freire({ pt: "Avaliação" })}:`}
                  bold={false}
                  {...(charge.stopValue !== null &&
                    charge.nps instanceof Object &&
                    typeof charge.nps.rating === "number" && {
                      value: (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              height: 9,
                              width: 9,
                              borderRadius: "50%",
                              marginRight: 8,
                              backgroundColor:
                                satismeterResults[
                                  satismeterSurveyMetrics[
                                    satismeterProject.surveys[
                                      charge.nps.surveyType
                                    ].metric
                                  ].getResult(charge.nps.rating)
                                ].color,
                            }}
                          />
                          {freire({
                            pt: `${freire(
                              satismeterSurveyMetrics[
                                satismeterProject.surveys[charge.nps.surveyType]
                                  .metric
                              ].text,
                            )} ${charge.nps.rating}${
                              charge.nps.comment ? " com comentário" : ""
                            }`,
                          })}
                        </div>
                      ),
                      tooltip: (
                        <div>
                          <div>
                            <div>
                              <strong>{freire({ pt: "Projeto" })}:</strong>{" "}
                              <Copy>{satismeterProject.name}</Copy>
                            </div>
                            <div>
                              <strong>{freire({ pt: "Pesquisa" })}:</strong>{" "}
                              <Copy>
                                {
                                  satismeterProject.surveys[
                                    charge.nps.surveyType
                                  ].name
                                }
                              </Copy>
                            </div>
                          </div>
                          <br />
                          <div>
                            <div>
                              <strong>{freire({ pt: "Resultado" })}:</strong>{" "}
                              <Copy>
                                {freire(
                                  satismeterResults[
                                    satismeterSurveyMetrics[
                                      satismeterProject.surveys[
                                        charge.nps.surveyType
                                      ].metric
                                    ].getResult(charge.nps.rating)
                                  ].text,
                                )}
                              </Copy>
                            </div>
                            <div>
                              <strong>{freire({ pt: "Comentário" })}:</strong>{" "}
                              <Copy>{charge.nps.comment}</Copy>
                            </div>
                          </div>
                          <br />
                          <div>
                            {/* TODO: rever segunda div */}
                            <div>
                              <a
                                rel="noopener noreferrer"
                                target="_blank"
                                // TODO: some querystring lib
                                href={`https://app.satismeter.com/projects/${
                                  satismeterProject.projectId
                                }/campaigns/${
                                  satismeterProject.surveys[
                                    charge.nps.surveyType
                                  ].surveyId
                                }/dashboard?filters=%5B%7B%22attribute%22%3A%22user.traits.idDaResposta%22%2C%22operator%22%3A%22eq%22%2C%22value%22%3A%22${
                                  charge.nps.npsId
                                }%22%2C%22type%22%3A%22string%22%7D%5D&startDate=${moment
                                  .utc(charge.startDateTime)
                                  .subtract(1, "day")
                                  .format("YYYY-MM-DD")}&endDate=${moment
                                  .utc(charge.stopDateTime)
                                  .add(1, "day")
                                  .format("YYYY-MM-DD")}`}
                              >
                                {freire({ pt: "Ver no Satismeter" })}
                              </a>
                            </div>
                          </div>
                        </div>
                      ),
                    })}
                />
                <InfoRow
                  labelSpan={7}
                  valueSpan={17}
                  label={`${freire(texts.VALUE)}:`}
                  value={
                    charge.stopValue === null ? (
                      "----"
                    ) : (
                      <>
                        <span>
                          {formatters.currency(
                            freire.userLanguage,
                            charge.currency,
                          )(getChargeDisplayAmounts(charge).chargeValue / 100)}
                        </span>
                        {getChargeDisplayAmounts(charge).discountValue > 0 && (
                          <>
                            {" "}
                            <DiscountValue charge={charge} freire={freire} />
                          </>
                        )}
                      </>
                    )
                  }
                  {...(charge.stopValue !== null
                    ? {
                        extraItems:
                          charge?.coupon2?.payer === ChargePayer.CPO ? (
                            <Tag
                              color="brown"
                              style={{ marginLeft: 8, borderRadius: 10 }}
                            >
                              {freire(texts.FLEET_BENEFIT)}
                            </Tag>
                          ) : (
                            <>
                              <PaymentStatus
                                chargeValue={
                                  getChargeDisplayAmounts(charge).chargeValue
                                }
                                freire={freire}
                                paymentSuccess={charge.paymentSuccess}
                                posPayment={charge.posPayment}
                              />
                              {
                                // eslint-disable-next-line eqeqeq
                                charge.paymentMethod != undefined && (
                                  <Tag
                                    color="blue"
                                    className="paymentStatusTag"
                                    style={{ paddingLeft: 5 }}
                                  >
                                    {BRANDS[charge.paymentMethod.brand] ??
                                      charge.paymentMethod.brand ??
                                      "Crédito"}
                                    {charge.paymentMethod.suffix !==
                                      undefined &&
                                      ` ${charge.paymentMethod.suffix}`}
                                  </Tag>
                                )
                              }
                            </>
                          ),
                      }
                    : {
                        // TODO?: refatorar a condição acima
                        extraItems: (
                          <Tag
                            // color="green"
                            color="orange"
                            className="paymentStatusTag"
                            style={{ paddingLeft: 6 }}
                          >
                            <Icon
                              component={() => (
                                <PowerPlugIcon
                                  // color="#48ac16"
                                  color="#eb7c05"
                                />
                              )}
                              // type="loading"
                              style={{
                                marginRight: 4,
                              }}
                            />
                            {freire(texts.CHARGING)}
                          </Tag>
                        ),
                      })}
                  bold={false}
                />
                <InfoRow
                  labelSpan={7}
                  valueSpan={17}
                  label={`${freire(texts.CHARGING_MODE)}:`}
                  value={getChargingModeInfo(charge)}
                  bold={false}
                />
                <InfoRow
                  labelSpan={7}
                  valueSpan={17}
                  label={`${freire(texts.DURATION)}:`}
                  value={`Inicio: ${moment(charge.startDateTime).format(
                    "L LTS",
                  )}`}
                  extraItems={
                    <Tag
                      className="paymentStatusTag"
                      style={{ paddingLeft: 6 }}
                    >
                      <Icon
                        type="clock-circle"
                        style={{
                          marginRight: 5,
                        }}
                      />
                      {formatters.duration(freire)(
                        moment(charge.stopDateTime ?? undefined).diff(
                          charge.startDateTime,
                          "hours",
                        ) === 0
                          ? moment.duration(
                              moment(charge.stopDateTime ?? undefined).diff(
                                charge.startDateTime,
                                "minutes",
                              ),
                              "minutes",
                            )
                          : moment.duration(
                              moment(charge.stopDateTime ?? undefined).diff(
                                charge.startDateTime,
                                "hours",
                              ),
                              "hours",
                            ),
                      )}
                    </Tag>
                  }
                  {...(charge.stopValue !== null && {
                    // TODO: arrumar para todos esses exibirem do mesmo jeito a duração
                    tooltip: freire(
                      texts.AGO(
                        formatters.duration(freire)(
                          moment().diff(charge.stopDateTime, "hours") === 0
                            ? moment.duration(
                                moment().diff(charge.stopDateTime, "minutes"),
                                "minutes",
                              )
                            : moment.duration(
                                moment().diff(charge.stopDateTime, "hours"),
                                "hours",
                              ),
                        ),
                      ),
                    ),
                  })}
                  bold={false}
                />
                {hasIdlePayment(charge) && (
                  <IdleStartRow charge={charge} texts={texts} freire={freire} />
                )}
              </Card>
            ))
          ) : (
            <Empty
              description={
                charges.length > 0
                  ? "Nenhuma carga encontrada para esse transactionID."
                  : freire(texts.USER_EMPTY_CHARGES)
              }
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          )}
        </>
      )}
    </div>
  );
};

Charges.propTypes = {
  userID: PropTypes.string,
};

export default Charges;
